<script>
function night(v) {
  let text = '';
  if (v === 1) text = 'день';
  if (v > 1 && v < 5) text = 'дня';
  if (v === 0 || v >= 5) text = 'дней';
  return text;
}

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        from: 1,
        to: 2,
      }),
    },
  },
  data() {
    return {
      hover: 0,
      active: false,
    };
  },
  methods: {
    handlerInput() {
      if (this.value.to || this.value.to === 0) {
        this.$emit('input', this.value);
        this.$emit('change', this.value);
      }
    },
    click(v) {
      if (this.value.to || this.value.to === 0) {
        this.value.to = null;
        this.value.from = v;
      } else {
        if (this.value.from > v) {
          this.value.to = this.value.from;
          this.value.from = v;
        } else {
          this.value.to = v;
        }
        this.$refs.popover1.showPopper = false;
      }
      this.handlerInput();
    },
    mouseenter(v) {
      this.hover = v;
    },
    class_item(value) {
      const data = {
        available: true,
      };
      const { from, to = this.hover } = this.value;
      if (from === value) data['start-date'] = true;
      if (to === value) data['end-date'] = true;
      if (from <= value && value <= to) data['in-range'] = true;
      return data;
    },
  },
  computed: {
    label() {
      if (!(this.value.from || this.value.from === 0)) {
        return 'Выберите';
      }
      if (!(this.value.to || this.value.to === 0)) {
        return `c ${this.value.from} ${this.value.from === 1 ? 'день' : 'дней'}`;
      }
      if (this.value.from !== this.value.to) {
        return `c ${this.value.from} по ${this.value.to} дней`;
      }
      return `${this.value.from} ${night(this.value.from)}`;
    },
  },
  mounted() {
    this.$watch('$refs.popover1.showPopper', (show) => {
      this.active = show;
      if (!show && !(this.value.to || this.value.to === 0)) {
        this.click(this.value.from);
      }
    });
  },
};
</script>
<template>
  <div class="f-c-duration">
    <el-popover ref="popover1" placement="bottom-start" trigger="click">
      <table class="el-date-table" cellspacing="0" cellpadding="0">
        <tbody>
        <tr v-for="i in 5" :key="i">
          <td
            v-for="j in 7"
            :key="j"
            @click="click(j+((i-1)*7) - 1)"
            @mouseenter="mouseenter(j+((i-1)*7) - 1)"
            v-show="(j+((i-1)*7) - 1)<32"
            :class="class_item(j+((i-1)*7) - 1)">
            <div>
              <span>{{j+((i-1)*7) - 1}}</span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </el-popover>
    <div
      class="f-c-input"
      v-popover:popover1
    >
      {{ label }}
    </div>
  </div>
</template>
<style lang="scss">
  .f-c-duration {
  }
</style>
